import axios from "axios";
export const fetchImage = async (data) => {
    try {
      return `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_BUCKET_REGION}.amazonaws.com/${data}`;
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };
